import { useLocation, useSearchParams } from "react-router-dom";
import { IUrlParamsMap } from "../../routing/IUrlParamsMap";

export type TUrlSchemaKeys = Partial<keyof IUrlParamsMap>;

// --
// -- Example:
/*  const param = useSchemaSearchParams();
    param
      .delete('auth-form')
      .delete('email-remember')
      .push();
*/
export default function useSchemaSearchParams() {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const paramMap = new URLSearchParams(location.search);  
  // const paramMap = new URLSearchParams(searchParams);  

  return {
    get: <K extends TUrlSchemaKeys>(key: K): IUrlParamsMap[K] | '' => paramMap.get(String(key)) as IUrlParamsMap[K] || '',     
    set: function <K extends TUrlSchemaKeys>(key: K, value: IUrlParamsMap[K]) {
      paramMap.set(String(key), value as string);
      return this;
    },
    setMap (map: Record<TUrlSchemaKeys, string | number>) {
      Object.entries(map)
        .reduce((acc, [key, val]) => String(val).trim()
            ? acc.set(key as TUrlSchemaKeys, String(val))
            : acc.delete(key as TUrlSchemaKeys)
          , this)
        .push();
    },
    delete: function <K extends TUrlSchemaKeys>(key: K) {
      paramMap.delete(String(key));
      return this;
    },
    push: function () {
      setSearchParams(paramMap, { replace: true });
      return this;
    },
    toString: () => paramMap.toString(),
    searchParams,
    paramMap,
    params: () => Object.fromEntries(paramMap.entries()),
    getParamsByKeys: (keys?: string[]) => (keys || [])
      .reduce((acc, key) => ({
        ...acc,
        ...(paramMap.get(key) && paramMap.get(key) !== 'null'
          ? { [key]: paramMap.get(key) }
          : {}
        )
      }), {})
    // Pagable
    // getPageParams: function (): IPageParams {
    //   return {
    //     page: Number(paramMap.get('page')) || 1,
    //     size: Number(paramMap.get('size')) || 1,
    //     q: paramMap.get('q') || '',
    //     sort: paramMap.get('sort') || '',
    //     sortDirection: paramMap.get('sortDirection') === 'asc' && 'asc'
    //       || paramMap.get('sortDirection') === 'desc' && 'desc'
    //       || undefined,
    //   };
    // },
    // updatePageParams: function (pageParams: Partial<IPageParams>) {
    //   Object.entries(pageParams).forEach(([key, value]) => paramMap.set(key, value as string));
    //   replace(`${pathname}?${String(paramMap)}`);
    // },
  }
}